webpackJsonp([144388295671145],{

/***/ 1180:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/protections-coverages/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-protections-coverages-ec74d80d8aefc7f43dd7.js